import React from "react";

export default () => {
  return (
    <div className="showcase" id="home">
      <div className="container">
        <div className="showcase__title">
          <h1 className="showcase__title-heading-1">
            <strong className="showcase__title-heading-1--strong">
              Daniel
            </strong>{" "}
            Ferreira
          </h1>
          <h3 className="showcase__title-heading-2">Front End Developer</h3>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Showcase.js